import { useEffect, useState } from 'react';

interface VoiceVisualizerProps {
  isActive: boolean;
  isSpeaking: boolean;
}

export default function VoiceVisualizer({ isActive, isSpeaking }: VoiceVisualizerProps) {
  const [levels, setLevels] = useState<number[]>([0.3, 0.3, 0.3, 0.3, 0.3]);

  useEffect(() => {
    if (!isActive || !isSpeaking) {
      setLevels([0.3, 0.3, 0.3, 0.3, 0.3]);
      return;
    }

    const interval = setInterval(() => {
      setLevels(
        Array.from({ length: 5 }, () => 0.3 + Math.random() * 0.7)
      );
    }, 100);

    return () => clearInterval(interval);
  }, [isActive, isSpeaking]);

  return (
    <div className="flex items-center justify-center gap-1 h-12">
      {levels.map((level, i) => (
        <div
          key={i}
          className={`w-1.5 rounded-full transition-all duration-100 ${
            isActive
              ? isSpeaking
                ? 'bg-primary-500'
                : 'bg-surface-600'
              : 'bg-surface-700'
          }`}
          style={{
            height: `${level * 100}%`,
            transform: `scaleY(${level})`,
          }}
        />
      ))}
    </div>
  );
}




